const TITLE_MAP = {
  student_accommodation: "Room Types",
  apartments: "Apartment Types",
  independent_house: "Unit Type",
} as const;

export default TITLE_MAP;
